module.exports = __webpack_public_path__ + "img/Thor Ragnarok.f4d37ec5.jpeg";